import React from 'react';
import { Header, Title } from 'components';
import { Container } from './Payment.style';
import { usePaymentVM } from './usePaymentVm';
import PaymentModePicker from './PaymentModePicker';
import StripePaymentMethod from './StripePaymentMethod';

const Payment: React.FunctionComponent = () => {
    const {
        paymentStep,
        paymentMode,
        goBack,
        resetPaymentStep,
        handlePaymentModeConfirm,
        handlePaymentModeChange,
        handleStripePaymentSubmit,
        isLoadingCreateOrder,
        errorCreateOrder,
    } = usePaymentVM();

    return (
        <Container>
            <Header>
                <Header.Left>
                    <Header.Back
                        onClick={
                            paymentStep === 'choose_payment_method' ? goBack : resetPaymentStep
                        }
                    />
                </Header.Left>
                <Header.Center>
                    <Title text="order_confirmation" type="large" weight="regular" />
                </Header.Center>
            </Header>
            {paymentStep === 'choose_payment_method' && (
                <PaymentModePicker
                    paymentMode={paymentMode}
                    handlePaymentModeConfirm={handlePaymentModeConfirm}
                    handlePaymentModeChange={handlePaymentModeChange}
                />
            )}
            {paymentStep === 'stripe_order_confirmation' && paymentMode === 'stripe' && (
                <StripePaymentMethod
                    handleStripePaymentSubmit={handleStripePaymentSubmit}
                    isLoading={isLoadingCreateOrder}
                    error={errorCreateOrder}
                />
            )}
        </Container>
    );
};

export default Payment;
